<template lang="pug">
modal(:max-width="400")
	.card.text-left
		.card-header.bg-warning
			span.fa.fa-search.mr-2
			| Buscador
			button.close(@click="cerrar") &times;
		.card-body
			.form-group
				label Cadena de texto
				input.form-control(placeholder="Etiqueta / descripción / nombre...", v-model="filtro.cadena", @keypress.enter="buscar")
			.form-group
				label Tipo de elementos
				br
				.btn-group
					button.btn(:class="(filtro.tipo === null) ? 'btn-primary' : ''", @click="setTipo(null)") Todos
					button.btn(:class="(filtro.tipo === 'galerias') ? 'btn-primary' : ''", @click="setTipo('galerias')") Galerias
					button.btn(:class="(filtro.tipo === 'items') ? 'btn-primary' : ''", @click="setTipo('items')") Ficheros
		.card-footer
			button.btn.btn-primary(@click="buscar")
				span.fa.fa-search.mr-2
				| Buscar
</template>

<script>
export default {
	data () {
		return {
			filtro: {
				cadena: '',
				tipo: null,
				fecha: null
			}
		}
	},
	methods: {
		setTipo (tipo) {
			this.filtro.tipo = tipo
		},
		cerrar () {
			this.$emit('cerrar')
		},
		buscar () {
			this.$store.dispatch('galerias/buscar', this.filtro)
			this.$router.push('/main/galerias/buscador')
			this.cerrar()
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/galerias/vue/componentes/buscador/modal-buscador.vue